// eslint-disable-next-line import/prefer-default-export
export const SHOP_THIS_STORE_URL_QUERY_KEY = 'shop-this-store';

export const SHOP_THIS_STORE_ACCESSIBLE_COMPONENTS = {
  SHOP_THIS_STORE: '/ShopThisStore',
  OLD_PLP: '/ProductListing',
  NEW_PLP: '/CategoryListingPage',
  SEARCH: '/SearchDetail',
  PDP: '/ProductDetail',
};

export const SHOP_STORE_RECENT_SEARCH = 'shop-this-store-recent-search';

export const SHOP_STORE_RECENT_SEARCHES_NUM_MAX = 10;

export const SHOP_THIS_STORE_SCROLL = 'shopThisStoreScroll';

export const SAVED_SHOP_THIS_STORE_URL = 'shopThisStorePrevUrl';

export const SHOP_THIS_STORE_EXIT_SEARCH_MODE = 'exitShopThisStoreSearchMode';
